/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import autobind from "autobind-decorator";
import {service as ConservationActionTypeService} from "../../../Services/ConservationActionTypeService";
import {BaseFieldViewer} from "./BaseFieldViewer";

export class ConservationActionTypeFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			conservationActionTypes: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ConservationActionTypeService.Get()
			.then((x) => {
				this.setState({conservationActionTypes: x.result});
			});
	}

	@autobind
	getConservationActionType() {
		return this.state.conservationActionTypes.find((x) => x.conservationActionTypeId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getConservationActionType() ? this.getConservationActionType().name : "N/A";
	}
}